/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Material_AddInputs */

const vi_pll_new_material_add = /** @type {(inputs: Pll_New_Material_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm vật tư`)
};

/**

* @param {Pll_New_Material_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_material_add = /** @type {((inputs?: Pll_New_Material_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Material_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_material_add(inputs)
});